import initExpandablePhotoGallery from "./expandable-photo-gallery";
import hamburgerButton from "./hamburger-button";
import scrolledListener from "./scrolled";
import visListener from "./vis";

(function ($) {
  $(document).ready(function () {
    initExpandablePhotoGallery($);
  });
})(jQuery);
